import { Link } from "react-router-dom";
import BasicLayout from "../layouts/basic";

const ErrorPage = () => {
  return (
    <BasicLayout>
      <div className="relative h-[80vh] overflow-hidden">
        <div className="z-10 flex flex-col justify-center items-center h-full gap-4">
          <p className="text-6xl font-bold font-title text-gray-300">404</p>
          <p className="text-lg font-medium text-gray-600">
            Page not found
          </p>
          <Link
            to="/"
            className="mt-4 px-6 py-2 rounded-full bg-green-500 text-white font-medium hover:bg-green-600 transition-colors"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </BasicLayout>
  );
};

export default ErrorPage;
